// extracted by mini-css-extract-plugin
export default {"error":"_30UNQ","button":"BAd8f"};